import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import { NamedLink } from '../../../components';

import css from './SectionHero.module.css';

import reversedLogo from '../images/reversedLogo.png';
import couchPic from '../images/Home-2.png';
import bathroomPic from '../../../components/Topbar/TopbarDesktop/gateImages/arch/Bathroom-arch.png';
import bedroomPic from '../../../components/Topbar/TopbarDesktop/gateImages/arch/Bedroom-arch.png';
import diningPic from '../../../components/Topbar/TopbarDesktop/gateImages/arch/Dining-arch.png';
import hallwayPic from '../../../components/Topbar/TopbarDesktop/gateImages/arch/Hallway-arch.png';
import kitchenPic from '../../../components/Topbar/TopbarDesktop/gateImages/arch/Kitchen-arch.png';
import laundryPic from '../../../components/Topbar/TopbarDesktop/gateImages/arch/Laundry-arch.png';
import livingPic from '../../../components/Topbar/TopbarDesktop/gateImages/arch/Living-arch.png';
import nurseryPic from '../../../components/Topbar/TopbarDesktop/gateImages/arch/Nursery-arch.png';
import officePic from '../../../components/Topbar/TopbarDesktop/gateImages/arch/Office-arch.png';
import outdoorPic from '../../../components/Topbar/TopbarDesktop/gateImages/arch/Outdoor-arch.png';
//product
import productPic from '../../../components/Topbar/TopbarDesktop/gateImages/arch/Product-arch.jpg';
import artPic from '../../../components/Topbar/TopbarDesktop/gateImages/arch/Art-arch.png';
import bedsPic from '../../../components/Topbar/TopbarDesktop/gateImages/arch/Beds-arch.png';
import chairsPic from '../../../components/Topbar/TopbarDesktop/gateImages/arch/Chairs-arch.png';
import sofaPic from '../../../components/Topbar/TopbarDesktop/gateImages/arch/Couches-arch.png';
import interiorsPic from '../../../components/Topbar/TopbarDesktop/gateImages/arch/Interiors-jug-arch.png';
import lightingPic from '../../../components/Topbar/TopbarDesktop/gateImages/arch/Interiors-light-arch.png';
import outdoorFurniturePic from '../../../components/Topbar/TopbarDesktop/gateImages/arch/Outdoor-furniture-arch.png';
import storagePic from '../../../components/Topbar/TopbarDesktop/gateImages/arch/Storage-arch.png';
import tablePic from '../../../components/Topbar/TopbarDesktop/gateImages/arch/Tables-arch.png';
import tablewarePic from '../../../components/Topbar/TopbarDesktop/gateImages/arch/Tableware - arch.png';



const SectionHero = props => {
  const {
    rootClassName,
    className,
    gateImage,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.heroLeft}>
        <div className={css.heroLeftContent}>
          <div className={css.heroLeftText}>
            <p className={css.tightText}>A marketplace</p>
            <p className={css.tightText}>for timeless</p>
            <p className={css.tightText}>interiors &</p>
            <p className={css.tightText}>furniture</p>
          </div>
          <div className={css.heroLeftButtons}>
            <NamedLink name="SearchPage" className={css.heroLeftButton}>
              SHOP
            </NamedLink>
            <NamedLink name="NewListingPage" className={css.heroLeftButton}>
              SELL
            </NamedLink>
          </div>
        </div>
      </div>
      <div className={css.heroRight}>
        <div className={css.heroRightImageWrapper}>
          {/* ############################################### */}
          <img
            src={reversedLogo}
            className={css.reversedLogoAnimated}
          />
          {/*################################## gate images */}
          <img
            src={couchPic}
            className={gateImage === 'couchTexture' ? css.gatePic : css.gatePicHidden}
          />

          <img
            src={bathroomPic}
            className={gateImage === 'bathroomPic' ? css.gatePic : css.gatePicHidden}
          />
          <img
            src={bedroomPic}
            className={gateImage === 'bedroomPic' ? css.gatePic : css.gatePicHidden}
          />
          <img
            src={diningPic}
            className={gateImage === 'diningPic' ? css.gatePic : css.gatePicHidden}
          />
          <img
            src={hallwayPic}
            className={gateImage === 'hallwayPic' ? css.gatePic : css.gatePicHidden}
          />
          <img
            src={kitchenPic}
            className={gateImage === 'kitchenPic' ? css.gatePic : css.gatePicHidden}
          />
          <img
            src={laundryPic}
            className={gateImage === 'laundryPic' ? css.gatePic : css.gatePicHidden}
          />
          <img
            src={livingPic}
            className={gateImage === 'livingPic' ? css.gatePic : css.gatePicHidden}
          />
          <img
            src={nurseryPic}
            className={gateImage === 'nurseryPic' ? css.gatePic : css.gatePicHidden}
          />
          <img
            src={officePic}
            className={gateImage === 'officePic' ? css.gatePic : css.gatePicHidden}
          />
          <img
            src={outdoorPic}
            className={gateImage === 'outdoorPic' ? css.gatePic : css.gatePicHidden}
          />
          <img
            src={productPic}
            className={gateImage === 'productPic' ? css.gatePic : css.gatePicHidden}
          />



          <img
            src={artPic}
            className={gateImage === 'artPic' ? css.gatePic : css.gatePicHidden}
          />
          <img
            src={bedsPic}
            className={gateImage === 'bedsPic' ? css.gatePic : css.gatePicHidden}
          />
          <img
            src={chairsPic}
            className={gateImage === 'chairsPic' ? css.gatePic : css.gatePicHidden}
          />
          <img
            src={sofaPic}
            className={gateImage === 'sofaPic' ? css.gatePic : css.gatePicHidden}
          />
          <img
            src={interiorsPic}
            className={gateImage === 'interiorsPic' ? css.gatePic : css.gatePicHidden}
          />
          <img
            src={lightingPic}
            className={gateImage === 'lightingPic' ? css.gatePic : css.gatePicHidden}
          />
          <img
            src={outdoorFurniturePic}
            className={gateImage === 'outdoorFurniturePic' ? css.gatePic : css.gatePicHidden}
          />
          <img
            src={storagePic}
            className={gateImage === 'storagePic' ? css.gatePic : css.gatePicHidden}
          />
          <img
            src={tablePic}
            className={gateImage === 'tablePic' ? css.gatePic : css.gatePicHidden}
          />
          <img
            src={tablewarePic}
            className={gateImage === 'tablewarePic' ? css.gatePic : css.gatePicHidden}
          />
        </div>
      </div>
    </div>
  );
};

SectionHero.defaultProps = { rootClassName: null, className: null };

SectionHero.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionHero;
